import React from "react";
import { Link } from "react-router-dom";

import {
  formatDateTime,
  timezones,
  getTimezoneDate,
  getSinglarOrPluralWord,
  formatNumber,
} from "../../../../utilities/helpers";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import placeholder from "../../../../assets/placeholder.png";

export default function Event({ event, tickets, handleClick }) {
  const timezone = timezones(event?.venue?.timezone);

  return (
    <Stack gap={3} as="ul">
      <Button
        variant="default"
        className="m-0 p-0"
        onClick={(e) => handleClick(e, { event, tickets })}
      >
        <Card as="li" className="card--light card-xs">
          <Card.Body className="d-flex-column flex-md-row gap-3 justify-content-between">
            <div className="d-flex-column flex-md-row gap-3">
              <div className="card-img-container card-img-container-sm">
                <Card.Img
                  src={event?.image?.url || placeholder}
                  alt={`Cover art for ${event?.name} event`}
                  width="78"
                  height="78"
                />
              </div>
              <Stack
                gap={2}
                className="justify-content-center align-items-start"
              >
                <Card.Title as="h5" className="card-title-sm m-0">
                  {event?.name}
                </Card.Title>
                <Card.Subtitle as="h6" className="fw-medium">
                  <span>
                    {formatDateTime(
                      getTimezoneDate(event?.start, timezone),
                      "seoDate",
                    )}
                  </span>
                  ,{" "}
                  <span>
                    {formatDateTime(
                      getTimezoneDate(event?.start, timezone),
                      "timeOnly",
                    )}
                  </span>
                </Card.Subtitle>
                <Card.Text className="small small-bold text-muted">
                  {event?.organization?.name}
                </Card.Text>
                <span className="num-tickets">
                  {formatNumber(tickets?.length)}{" "}
                  {getSinglarOrPluralWord(tickets?.length)}
                </span>
              </Stack>
            </div>
            <span className="m-0 btn btn-primary align-self-md-center">
              Event details
            </span>
          </Card.Body>
        </Card>
      </Button>
    </Stack>
  );
}
